__turbopack_context__.v({
  "bullets": "Ya431G_bullets",
  "caption": "Ya431G_caption",
  "card": "Ya431G_card",
  "carousel": "Ya431G_carousel",
  "close": "Ya431G_close",
  "control": "Ya431G_control",
  "controls": "Ya431G_controls",
  "direction": "Ya431G_direction",
  "eyebrow": "Ya431G_eyebrow",
  "focusPlayback": "Ya431G_focusPlayback",
  "ground": "Ya431G_ground",
  "heading": "Ya431G_heading",
  "item": "Ya431G_item",
  "link": "Ya431G_link",
  "modal": "Ya431G_modal",
  "modalCaption": "Ya431G_modalCaption",
  "modalCopy": "Ya431G_modalCopy",
  "modalImage": "Ya431G_modalImage",
  "photo": "Ya431G_photo",
  "ring": "Ya431G_ring",
  "section": "Ya431G_section",
  "soon": "Ya431G_soon",
  "stage": "Ya431G_stage",
  "tag": "Ya431G_tag",
  "watermark": "Ya431G_watermark",
});
